export const TagBadge = ({ tag }: { tag: string }) => {
  return (
    <span className="rounded-[16px] bg-[#ff8a00] px-2 py-0.5 text-[12px] font-bold leading-[16px] text-white">
      {tag}
    </span>
  )
}
